<template>
    <div class="home-news">
        <content-header class="home-content home-content-header" text="Новости"></content-header>
        <news-cards class="home-content home-news-cards"></news-cards>
    </div>
</template>
<script>

import ContentHeader from '@/components/content/ContentHeader.vue'
import NewsCards from '@/components/news/NewsCards.vue'

export default{
    name: 'HomeNews',
    components: {
        ContentHeader,
        NewsCards
    }
}
</script>